import { FlexView, Row, Text } from '@cuemath/comps';
import styled from 'styled-components';
import COLORS from 'constants/colors';
import { Link } from 'react-router-dom';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FetchErrorContainer = styled(FlexView)`
  margin: 200px;
`;

const Heading = styled(Text)`
  background-color: ${COLORS.HAWKESBLUE};
  border: 1px solid ${COLORS.SCIENCEBLUE};
  text-align: center;
  padding: 6px;
  margin: 20px 10px 0 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const InfoWrapper = styled.div`
  border: 1px solid ${COLORS.SILVERCHALICE};
  border-top-color: transparent;
  margin: 0 10px;
  padding: 10px 10px 30px 10px;
`;

const LabelWrapper = styled(Text)`
  margin: 5px 0;
`;

const ValueWrapper = styled(Text)`
  border-bottom: 1px solid black;
  word-break: break-all;
  user-select: ${({ disableUserSelect }) => (disableUserSelect ? 'none' : 'auto')};
`;

const LinkWrapper = styled(Text)`
  color: ${COLORS.BOSTON_BLUE};
  text-decoration: none;
  cursor: pointer;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-left: 20px;
  padding-right: 20px;
`;

const FilterWrapper = styled(Row)`
  width: 100%;
  padding: 0 20px 10px 20px;
  justify-content: space-between;
`;

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

export {
  LinkWrapper,
  FilterWrapper,
  FullFlexView,
  LinkNav,
  TableWrapper,
  ValueWrapper,
  LabelWrapper,
  InfoWrapper,
  Heading,
  FetchErrorContainer,
  Wrapper,
};
